import { useLocation, Link } from "react-router-dom";
import { useEffect, useState } from "react";

const pages = [
  { title: "Home", path: "/" },
  { title: "About Us", path: "/about" },
  { title: "Chat", path: "/chat" },
  { title: "Profile", path: "/profile" },
  { title: "Tuition Fee", path: "/tuition-fee" },
];

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchPage = () => {
  const query = useQuery();
  const q = query.get("q") || "";
  const [results, setResults] = useState<typeof pages>([]);

  useEffect(() => {
    const filtered = pages.filter((page) => page.title.toLowerCase().includes(q.toLowerCase()));
    setResults(filtered);
  }, [q]);

  return (
    <div className="search-results">
      <h2>Search result: "{q}"</h2>
      {results.length > 0 ? (
        <ul>
          {results.map((page, idx) => (
            <li key={idx}>
              <Link to={page.path}>{page.title}</Link>
            </li>
          ))}
        </ul>
      ) : (
        <p>Nothing there.</p>
      )}
    </div>
  );
};

export default SearchPage;
